import React, { useState } from "react";
import { useLocation } from "react-router-dom";

import { Button, Checkbox, Dialog, TextField, Box } from "@material-ui/core";
import { useTranslation } from "localization/translation";
import * as Api from "service";
import { getQueryParam } from "helpers/getQueryParam";
import { USER_ID, BILLING_EMAIL_ERROR_MSG } from "Constants";
import useStore from "context";
import { Check } from "@material-ui/icons";

export const UserBillingEmail = ({
  isBillingEmailMode,
  setIsBillingEmailMode,
  setUserDetails,
  user_billing_email,
  user_billing_email_id,
  isEditMode = false,
  isAdminEmail = false,
  isSendAdminEmail,
  setIsSendAdminEmail,
}) => {  
  const translation = useTranslation();
  const location = useLocation();
  const { setErrorMsg } = useStore();

  const [userBillingEmail, setUserBillingEmail] = useState(user_billing_email || null);
  const userId = getQueryParam(location, USER_ID);

  const cancelHandler = () => {
    setIsBillingEmailMode(false);
  };

  const saveHandler = async () => {
    if (userBillingEmail) {
      try {
        if(isEditMode) {
          if(isAdminEmail) {
            await Api.userBillingEmails.update({
              clientId: userId,
              billing_email_id: user_billing_email_id,
              isSendAdminEmail: isSendAdminEmail,
            });
          } else {
            await Api.userBillingEmails.update({
              clientId: userId,
              billing_email_id: user_billing_email_id,
              email: userBillingEmail,
            });
          }
        } else {
          await Api.userBillingEmails.create({
            clientId: userId,
            email: userBillingEmail,
          });
        }
        const { data } = await Api.main.getUserDetails(userId);
        setUserDetails(data);
        setIsBillingEmailMode(false);
      } catch (error) {
        setErrorMsg(BILLING_EMAIL_ERROR_MSG);
      }
    }
  };

  return (
    <Dialog
      open={isBillingEmailMode}
      onClose={cancelHandler}
      classes={{ paper: "shadow-lg rounded" }}
    >
      <div className="text-center pt-2 pb-5 pl-5 pr-5">
        <h4 className="font-weight-bold mt-4">
          {translation.user_billing_email}
        </h4>
        {
          isAdminEmail ? (
            <Box>
              <Checkbox
                checked={isSendAdminEmail}
                onChange={(e) => setIsSendAdminEmail(e.target.checked)}
              />
              <span className="ml-2">{translation.is_send_admin_email}</span>
            </Box>
          ) : (
            <TextField
              id="outlined-basic"
              label={translation.user_billing_email}
              variant="outlined"
              value={userBillingEmail}
              type="text"
              onChange={(e) => setUserBillingEmail(e.target.value)}
            />
          )
        }
        <div className="pt-4">
          <Button
            onClick={() => setIsBillingEmailMode(false)}
            className="btn-neutral-secondary btn-pill mx-1"
          >
            <span className="btn-wrapper--label">{translation.cancel}</span>
          </Button>
          <Button
            onClick={saveHandler}
            className={`btn-danger btn-pill mx-1 activate`}
          >
            <span className="btn-wrapper--label btn-action">
              {translation.save}
            </span>
          </Button>
        </div>
      </div>
    </Dialog>
  );
};
